import { VrEvent } from './VrEvent';

export class SceneEvent extends VrEvent{
    public sceneId: number;
    public timeOfEvent: number;
}